<template>
    <v-container fluid class="pt-0">
        <v-toolbar dense max-width="250px" class="posicionar" v-if="toolbarBuscar" v-click-outside="cancelarFiltrado">
            <v-text-field v-model="buscadorNombre" hide-details single-line @input="filtradoTarjetas" autofocus></v-text-field>
            <v-btn icon @click="cancelarFiltrado">
                <v-icon >mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        
        <div dense class="posicionar elevation-0" v-if="buscarEquipo">
            <v-chip class="ma-2" close color="info" outlined @click:close="cancelarFiltradoEquipo()">
                {{ clienteSeleccionado.name }}
            </v-chip>
        </div>

        <v-speed-dial v-model="fab" fixed direction="top" transition="slide-y-reverse-transition" style="bottom: 37px; right: 30px;">
            <template v-slot:activator>
                <v-btn v-model="fab" color="teal lighten-1" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>
            
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" fab dark @click="activarFiltroTecnico()" small>
                        <v-icon>mdi-account-search-outline</v-icon>
                    </v-btn>
                </template>
                <span>Buscar usuario</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="indigo" fab dark @click="seleccionarCliente()" small>
                        <v-icon>mdi-briefcase-search-outline</v-icon>
                    </v-btn>
                </template>
                <span>Buscar equipo</span>
            </v-tooltip>
        </v-speed-dial>

        <v-layout wrap justify-center>
            <v-flex v-for="(item, index) in usuariosVisibles" :key="item.id" class="mb-2">
                    <v-card  width="350" min-height="205" class="mr-2">
                        <v-list-item>
                            <v-row>
                                <v-col md="5" align="center" class="pr-0 pl-0 pb-0">
                                    <div>
                                        <v-list-item-avatar size="70" :class="claseEstado(usuariosVisibles[index].id)">
                                            <v-avatar :color="usuariosVisibles[index].color" size="60">
                                                <span class="white--text headline">{{ usuariosVisibles[index].avatar }}</span>
                                            </v-avatar> 
                                        </v-list-item-avatar>
                                        
                                        <v-chip outlined :class="'v-chip-'+claseEstado(usuariosVisibles[index].id)">{{textoEstado(usuariosVisibles[index].id)}}</v-chip>
                                    </div>
                                </v-col>
                                
                                <v-col sm="7" md="7" class="pl-0 pt-0 mt-2 pb-0" align="center" align-self="center">
                                    <v-list-item-content class="pb-0 pt-0" height="20px">
                                        <p class="body-1"> {{ usuariosVisibles[index].name }} {{ usuariosVisibles[index].apellido }}</p>
                                        <a class="body-2" @click="enviarCorreo(usuariosVisibles[index])" >{{ usuariosVisibles[index].email }}</a>
                                    </v-list-item-content>
                                    <div class="mt-2 mb-0" v-if="usuariosVisibles[index].equipos.length != 0">
                                        <v-tooltip bottom v-for="equipo in usuariosVisibles[index].equipos" :key="equipo.id">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-chip :color="equipo.color" label style="width: 70px; height: 10px; cursor: pointer;"></v-chip>
                                                </span>
                                            </template>
                                            <span><v-icon small color="white">mdi-phone</v-icon> {{ equipo.extension }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="mt-2 mb-0" v-if="usuariosVisibles[index].comercial"> 
                                        <v-chip label outlined  color="purple" style="height: 20px">COMERCIAL</v-chip>
                                    </div>
                                    <div :class="usuariosVisibles[index].comercial ? 'mt-0 mb-0' : 'mt-2 mb-0'" v-if="usuariosVisibles[index].responsableCuenta && buscarEquipo"> 
                                        <v-chip label outlined  color="info" style="height: 20px">RESPONSABLE CUENTA</v-chip>
                                    </div>
                                </v-col>
                                <v-col cols="12" class="pt-1 pb-0">
                                    <p 
                                        style="color:gray" 
                                        align="center" 
                                        class="mb-0 body-2"  
                                        v-if="mensajeEstadoUsuario(usuariosVisibles[index].id)"
                                    >
                                        *{{ mensajeEstadoUsuario(usuariosVisibles[index].id) }}*
                                    </p>
                                    <p v-if="!mensajeEstadoUsuario(usuariosVisibles[index].id)"></p>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-card-actions>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"><v-icon :class="estadoExtension(usuariosVisibles[index].extension)">mdi-phone</v-icon></span>
                                </template>
                                <span>{{ textoEstadoExt(estadoExtension(usuariosVisibles[index].extension)) }}</span>
                            </v-tooltip>
                            {{ usuariosVisibles[index].extension }}
                            <v-spacer></v-spacer> 
                            <v-btn text @click="mostrarHorario(item)">Ver horario</v-btn>
                        </v-card-actions>
                    </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogHorario" persistent max-width="900">
            <v-card>
                <v-card-title>Horario de {{usuario.name}}</v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="horario"
                        hide-default-footer
                        class="elevation-1"
                    ></v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogHorario = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialogEscogerCliente" persistent max-width="600px">
            <v-card>
                <v-card-title><span class="headline">Cliente</span></v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete 
                                    :loading="loading" 
                                    :disabled="loading" 
                                    v-model="clienteSeleccionado" 
                                    :items="clientes" 
                                    chips 
                                    label="Selecciona" 
                                    item-text="name" 
                                    item-value="name" 
                                    return-object
                                    ref="input"
                                    autofocus
                                    @change="pressEnter()"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEscogerCliente=false, clienteSeleccionado = {}">Cerrar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        :disabled="this.$v.clienteSeleccionado.$invalid" 
                        @click="filtrarEquipoCliente()"
                        ref="buscar"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> 
    </v-container>  
</template>

<script>
    import axios from 'axios';
    import { mapActions } from 'vuex';
    import Echo from 'laravel-echo';
    import Pusher from 'pusher-js'
    import buscarEquipoCliente from "@/mixins/buscarEquipoCliente";
    import { required } from 'vuelidate/lib/validators';
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    export default {
        name: 'Ardiagenda',
        mixins: [ buscarEquipoCliente ],
        data: () => ({
            horejecutarFococtual:  new Date(),
            usuarios: [],
            usuariosFiltrados: [],
            dialogHorario: false,
            usuario: {},
            horarios: [],
            horario: [
                {
                    franja: 'Mañana',
                    lunes: '',
                    martes: '',
                    miercoles: '',
                    jueves: '',
                    viernes: '',
                },
                {
                    franja: 'Tarde',
                    lunes: '',
                    martes: '',
                    miercoles: '',
                    jueves: '',
                    viernes: '',
                },
            ],
            headers: [
                { text: '', value: 'franja', sortable: false },
                { text: 'Lunes', value: 'lunes', sortable: false },
                { text: 'Martes', value: 'martes', sortable: false },
                { text: 'Miércoles', value: 'miercoles', sortable: false },
                { text: 'Jueves', value: 'jueves', sortable: false },
                { text: 'Viernes', value: 'viernes', sortable: false },
            ],
            estadosExtensiones: [],
            estadosUsuarios: [],
            buscadorNombre: "",
            toolbarBuscar: false,
            fab: false,
            horaActual: new Date(),
            dialogEscogerCliente: false,
            loading: false,
            clientes: [],
            clienteSeleccionado: {},
            buscarEquipo: false,
            datosEquipoCliente: {}
        }),
        validations: {
            clienteSeleccionado: { required }
        },
        methods: {
            ...mapActions(['setLoading']),
            async mostrarHorario(usuarioClicado){
                this.usuario=usuarioClicado;
                
                this.setLoading(true);
                try {
                    let respuesta = await axios.get(`/api/horarios/${this.usuario.id}`); //Obtener el horario del usuario
                    respuesta.data.forEach(horario => {
                        if(horario.entradaManana && horario.salidaManana){
                            this.horario[0][horario.dia] = 'de ' + horario.entradaManana + ' a ' +  horario.salidaManana; 
                        }else{
                            this.horario[0][horario.dia] = 'No trabaja'; 
                        }

                        if(horario.entradaTarde && horario.salidaTarde){
                            this.horario[1][horario.dia] = 'de ' + horario.entradaTarde + ' a ' +  horario.salidaTarde;
                        }else{
                            this.horario[1][horario.dia] = 'No trabaja'; 
                        }
                    });

                    this.dialogHorario=true;
                    this.setLoading(false);
                } catch (error) {
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se ha podido recuperar el horario'
                    });
                }            
            },
            enviarCorreo(usuarioClicado){
                window.location.href = 'mailto:' + usuarioClicado.email;
            },    
            comprobarEstado(user_id){
                let horario = this.horarios.filter(h => h.user_id === user_id)[0];    
                
                let fecha = this.horaActual;
                let hora = (fecha.getHours() < 10 ? '0' + fecha.getHours() : fecha.getHours()) + ':' + (fecha.getMinutes() < 10 ? '0'+fecha.getMinutes() : fecha.getMinutes()) + ':00';

                if(horario && ((hora >= horario.entradaManana && hora < horario.salidaManana) || (hora >= horario.entradaTarde && hora < horario.salidaTarde))){ //si el usuario se encuentra dentro de la joranada
                    hora = hora.split(":");

                    //MIRO SI QUEDA MEDIA HORA O MENOS PARA ACABAR LA JORNADA
                    if(horario.salidaManana != null){
                        let manana = horario.salidaManana.split(":");
                        if((manana[0] - hora[0])*60 + parseInt(manana[1])-hora[1] <= 15 && (manana[0] - hora[0])*60 + parseInt(manana[1])-hora[1] > 0){
                            return 'terminando';
                        }
                    }
                    if(horario.salidaTarde != null){                    
                        let tarde = horario.salidaTarde.split(":");
                        if((tarde[0] - hora[0])*60 + parseInt(tarde[1])-hora[1] <= 15 && (tarde[0] - hora[0])*60 + parseInt(tarde[1])-hora[1] > 0){
                            return 'terminando';
                        }
                    }    
                    return 'disponible';
                }else{ //si el usuario no se encuentra dentro de su joranada
                    return 'fueraJornada';
                }
            }, 
            estadoExtension(ext){
                let estadoExtension = this.estadosExtensiones.filter(item => item.extension === ext)[0];
                if( estadoExtension !== undefined){
                    if(estadoExtension.presence_status === 'dnd'){
                        return 'dnd';
                    }
                    return estadoExtension.status;
                }else{
                    return 'Unavailable';
                }
            },
            textoEstadoExt(estadoExtension){
                if(estadoExtension == 'InUse'){
                    return 'Al teléfono';
                }else if(estadoExtension == 'Idle'){
                    return 'Disponible ';
                }else if(estadoExtension == 'Unavailable'){
                    return 'No disponible';
                }else if(estadoExtension == 'dnd'){
                    return 'No molestar';
                }else if(estadoExtension == 'Ringing'){
                    return 'Teléfono sonando';
                }
            },
            mensajeEstadoUsuario(user_id){
                let estado = this.estadosUsuarios.filter(usuario => usuario.user_id === user_id);
                if(estado.length > 0){
                    return estado[0].mensaje;
                }else{
                    return '';
                }
            },
            usuarioOcupado(user_id){
                let estado = this.estadosUsuarios.filter(usuario => usuario.user_id === user_id);
                if(estado.length > 0){
                    if (estado[0].ocupado === 1){
                        return true;
                    }
                    return false;
                }else{
                    return false;
                }
            },
            claseEstado(user_id){
                let ocupado = this.usuarioOcupado(user_id);
                let estado = this.comprobarEstado(user_id);
                
                if(ocupado && (estado === 'disponible' || estado === 'terminando')){
                    return 'ocupado';
                }
                return estado;
            },
            textoEstado(user_id){
                let clase = this.claseEstado(user_id);
                switch (clase) {
                    case 'disponible':
                        return 'Disponible';
                    case 'ocupado':
                        return 'Ocupado';
                    case 'terminando':
                        return 'Termina pronto';
                    case 'fueraJornada':
                        return 'Fuera jornada';
                }
            },
            actualizarEstados(){
                setInterval(() => {
                    this.horaActual = new Date();
                },1000);
            },
            filtradoTarjetas(){                
                this.usuariosFiltrados = this.usuarios.filter(u => u.nombreCompleto.toLowerCase().includes(this.buscadorNombre.toLowerCase()));
            },
            activarFiltroTecnico(){
                this.toolbarBuscar = true;
                if(this.buscarEquipo){
                    this.cancelarFiltradoEquipo();
                }
            },
            cancelarFiltrado(){
                this.buscadorNombre = '';
                this.usuariosFiltrados = this.usuarios;
                this.toolbarBuscar = false;
            },
            async filtrarEquipoCliente(){
                this.dialogEscogerCliente = false;
                this.setLoading(true);
                let respuesta = await this.buscarEquipoCliente(this.clienteSeleccionado.code);
                if(!respuesta.error){
                    this.datosEquipoCliente = respuesta;
                    this.buscarEquipo = true;
                }
                this.setLoading(false);
            },
            cancelarFiltradoEquipo(){
                this.buscarEquipo = false;
                this.usuariosFiltrados = this.usuarios;
                this.clienteSeleccionado = {};
                this.datosEquipoCliente = {};
            },
            async seleccionarCliente(){
                this.loading = true;
                this.cancelarFiltradoEquipo();
                this.dialogEscogerCliente = true;
                axios.get('/api/clientes').then(respuesta => {
                    this.loading = false;
                    this.clientes = respuesta.data;
                    this.ejecutarFoco();
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar los clientes'
                    });
                });
            },            
            ejecutarFoco(){
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });                
            },
            handleKeys () {
                //https://keycode.info/
                if (event.keyCode === 70 && event.ctrlKey) { //Si se pulsa ctrl+F 
                    event.preventDefault(); // cancelamos la accion por defecto dle navegador
                    this.activarFiltroTecnico(); // Activamos el filto de busqueda de tecnicos
                }

                if (event.keyCode === 83 && event.ctrlKey) { //Si se pulsa ctrl+S 
                    event.preventDefault(); // cancelamos la accion por defecto dle navegador
                    this.seleccionarCliente(); // Activamos el filto de busqueda de tecnicos y comerciales pertenecientes al cliente
                }
            },
            pressEnter () {
                if(this.dialogEscogerCliente == true){
                    this.$nextTick(() => {
                        this.$refs.buscar.$el.focus();
                    });
                }
            }
        },
        async created() {
            let dias = ['', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', ''];
            let dia = dias[new Date().getDay()];
            this.setLoading(true);
            try {
                let respuesta = await axios.get(`/api/horarios?dia=${dia}`); //OBTENER LOS HORARIOS DEL DIA ACTUAL DE CADA USUARIO
                this.horarios = respuesta.data;

                respuesta = await axios.get('/api/estadoUsuario'); //LISTAR LOS ESTADOS EXISTENTES
                this.estadosUsuarios = respuesta.data;

                respuesta = await axios.get('/api/usuarios?tipo=1'); //LISTAR TODOS LOS USUARIOS MENOS LOS USUARIOS DE SISTEMA
                this.usuarios = respuesta.data; //-------------------------------------------------exceptoTipo
                    
                this.usuarios.forEach(usuario => {
                    usuario.apellido = usuario.apellidos.split(" ");
                    if(usuario.apellido[0].charAt(0) == usuario.apellido[0].charAt(0).toUpperCase()){
                        usuario.apellido = usuario.apellido[0];
                    }else{
                        usuario.apellido = usuario.apellido[1]? usuario.apellido[0]+' '+usuario.apellido[1] : usuario.apellido[0];
                    }
                    usuario.nombreCompleto = usuario.name + ' ' + usuario.apellido;
                    this.comprobarEstado(usuario);

                    if(usuario.grupos.some(u => u.id === 3)){
                        usuario.comercial = true;
                    }
                });

                this.usuarios.sort(function(a, b) { //ordeno los usuarios por nombre
                    if (a.name.toUpperCase() === b.name.toUpperCase()) { // Si tienen el mismo nombre ordeno por apellido
                        return a.apellido.toUpperCase() > b.apellido.toUpperCase() ? 1 : -1;
                    }   
                    return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
                });

                this.usuariosFiltrados = this.usuarios;
                
                this.setLoading(false);
            } catch (error) {
                console.log(error);
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos'
                });
            }
        },
        mounted(){
            window.Pusher = Pusher
            window.Echo = new Echo({
                broadcaster: 'reverb',
                key: process.env.VUE_APP_REVERB_APP_KEY,
                wsHost: process.env.VUE_APP_REVERB_HOST,
                wsPort: process.env.VUE_APP_REVERB_PORT,
                wssPort: process.env.VUE_APP_REVERB_PORT,
                forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',
                enabledTransports: ['ws', 'wss'],
            })
            window.Echo.channel("channel-ardiagenda").listen("EstadoExtensiones", (data) => {
                let estadosExtensiones = Object.values(data);
                estadosExtensiones.pop();
                this.estadosExtensiones = estadosExtensiones;
            });
            window.Echo.channel("channel-ardiagenda").listen("EstadoUsuario", (data) => {
                let usuario = this.estadosUsuarios.filter(usuario => usuario.user_id === data.estado.user_id)[0];
                if (usuario === undefined){
                    this.estadosUsuarios.push(data.estado);
                }else{
                    usuario.mensaje = data.estado.mensaje;
                    usuario.ocupado = data.estado.ocupado;
                }
            });
            this.actualizarEstados();
            
            window.addEventListener('keydown', this.handleKeys);
        },
        destroyed() {
            window.Echo.leave("channel-ardiagenda");
            window.removeEventListener('keydown', this.handleKeys);
        },
        computed: {
            usuariosVisibles(){
                if(Object.keys(this.datosEquipoCliente).length){
                    let equipoCliente = this.datosEquipoCliente.equipoTecnico;
                    if(this.datosEquipoCliente.responsableCuenta){
                        equipoCliente.push(this.datosEquipoCliente.responsableCuenta);
                        let responsableCuenta = this.usuariosFiltrados.find(usuario => usuario.id === this.datosEquipoCliente.responsableCuenta.id);
                        responsableCuenta.responsableCuenta = true;
                    }
                    if(this.datosEquipoCliente.tecnicoReferencia) equipoCliente.push(this.datosEquipoCliente.tecnicoReferencia);
                    if(this.usuariosFiltrados.find(usuario => usuario.email === this.clienteSeleccionado.comercialEmail)) equipoCliente.push(this.usuariosFiltrados.find(usuario => usuario.email === this.clienteSeleccionado.comercialEmail));
                    return this.usuariosFiltrados.filter(usuario => equipoCliente.some(u => u.id === usuario.id));
                }
                return this.usuariosFiltrados;
            }
        }
    }
</script>

<style>
    .posicionar {
        z-index: 1;
        right: 0; 
        margin-right: 10px;
        top: 75px;
        position: fixed;
    }
    .flex {
        max-width: 370px !important;
    }
    .disponible {
        border: 2px dotted green;
    }
    .terminando {
        border: 2px dotted orange;
    }
    .fueraJornada {
        border: 2px dotted red;
    }
    .ocupado {
        border: 2px dotted purple;
    }
    .v-chip-disponible {
        color: green !important;
        border-color: green !important;
    }
    .v-chip-terminando {
        color: orange !important;
        border-color: orange !important;
    }
    .v-chip-fueraJornada {
        color: red !important;
        border-color: red !important;
    }
    .v-chip-ocupado {
        color: purple !important;
        border-color: purple !important;
    }
    .InUse {
        color: #e30000 !important;
    }
    .Idle {
        color: #088608 !important;
    }
    .Unavailable {
        color: #a2a2a2 !important;
    }
    .dnd{
        color: #2f2f2f !important;
    }
    .Ringing{
        color: #ff8300 !important;
    }
</style>